// extracted by mini-css-extract-plugin
module.exports = {"b_breadcrumbs":"Breadcrumbs_b_breadcrumbs__gq7CN","item":"Breadcrumbs_item__YlhT5"};